const COPYRIGHT_YEAR = '2O14';
export default COPYRIGHT_YEAR;
